export default "/images/65a735a8bb21a4b94853b7e86e6c44da.avif";